module.exports = __webpack_public_path__ + "img/ralphhagedorn.489e08f2.svg";